import { Ratings } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductStars from "../product-details-rate/ProductStars";
import RateDetails from "./RateDetails";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  menu?: boolean;
  productDetails?: boolean;
  rate: number;
  ratings: Ratings;
  flexColumn?: boolean;
}
const ReviewDetails: React.FC<Props> = ({
  menu,
  productDetails,
  rate,
  ratings,
  flexColumn,
}) => {
  const totalReview =
    !!ratings && Object.values(ratings).reduce((acc, curr) => acc + curr, 0);
  const t = useTranslation();
  return (
    <div className="review-details">
      <div
        className={`rate-average ${
          menu ? "menu" : productDetails ? "product-details-review" : ""
        } ${flexColumn ? "flex-column gap-0" : ""}`}
      >
        <div className="rate-value">{rate}</div>
        <div className={`rate-container`}>
          <ProductStars rate={rate} />
          <div className="rate-based-on">{`${t.based_on} ${+totalReview} ${
            t.reviews
          }`}</div>
        </div>
      </div>
      <RateDetails total={totalReview} ratings={ratings} />
    </div>
  );
};

export default ReviewDetails;
